import React, { useEffect } from 'react';

import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

import useModal from 'Hooks/useModal';

/** The shared Modal, opened and closed by `isOpen`, with the standard header. */
export default function DialogModal({ id, isOpen, onClose, title, subtitle, danger = false, widthClass = 'tw-max-w-xl', children }) {
    const modal = useModal();

    useEffect(() => {
        isOpen ? modal.show() : modal.hide();
    }, [isOpen, modal.show, modal.hide]);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const onKeyDown = (event) => event.key === 'Escape' && onClose();
        document.addEventListener('keydown', onKeyDown);

        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isOpen, onClose]);

    return (
        <Modal id={id} modal={modal} innerContainerClasses={widthClass}>
            <ModalHeader title={<span className={danger ? 'tw-text-red' : undefined}>{title}</span>} subtitle={subtitle} close={onClose} />
            {isOpen && children}
        </Modal>
    );
}
